import { Text } from '@latitude/text';
import { cn } from '@latitude/token-utils';
import type { ComponentRef, Ref } from 'react';
import type { SignalProps, SignalStatus } from 'types';
import { signalVariants } from 'variants';

const Signal = ({
  status = 'default',
  border = false,
  label = '',
  className,
  ref,
  ...rest
}: SignalProps & {
  ref?: Ref<ComponentRef<'div'>>;
}) => {
  return (
    <div
      {...rest}
      className={cn('flex', 'items-center', 'gap-sizing-sys-size-8', className)}
      ref={ref}
      data-testid="signal-container"
    >
      <div
        data-testid="signal-element"
        className={cn(signalVariants({ status, border }))}
      />
      {label && <Text color="strong">{label}</Text>}
    </div>
  );
};

Signal.displayName = 'Signal';

export { Signal, signalVariants, type SignalProps, type SignalStatus };
